import * as moment from 'vendors/moment-locale-th';

import { b64toutf8, utf8tob64 } from 'jsrsasign/lib/jsrsasign.js';

import $ from 'jquery';
import { AppConfigService } from '../app-config/app-config.service';
import { Injectable } from '@angular/core';
import { Language } from '../../model/constant';
import { nationalityList } from '../../utilities/nationalityList';

@Injectable()
export class UtilitiesService {
  public scrollTop: number;
  public isLockedBody = false;

  constructor(
    private appConfig: AppConfigService
  ) { }

  generateAuthorization(email: string) {
    return this.base64Encoder(`${email}:${this.appConfig.getTimeForAuthorizationHeader()}`);
  }

  base64Encoder(value) {
    try {
      return utf8tob64(value);
    } catch (e) {
      console.log('Error:', e);
      return '';
    }
  }

  base64Decoder(value) {
    try {
      return b64toutf8(value);
    } catch (e) { }

    try {
      return this.customBase64Decode(value);
    } catch (e) {
      console.log('Error:', e);
      return '';
    }
  }

  b64toBlob(b64Data, contentType = '', sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  customBase64Decode(s) {
    let b = 0, l = 0, r = '';
    const m = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');
    s.split('').forEach(function (v) {
      b = (b << 6) + m.indexOf(v); l += 6;
      while (l >= 8) {
        r += String.fromCharCode((b >>> (l -= 8)) & 0xff);
      }
    });
    return r;
  }

  reverseFormatDate(date) {
    const [d, m, y] = date.split('-');
    const newD = [y, m, d];
    return newD.join('-');
  }

  resolveSlugSpace(value: string) {
    let newValue = value.split(' ').join('-');
    return newValue;
  }

  getYearFormDateFormat(date, format) {
    switch (format) {
      case 'dd D MMM YYYY':
        return date.split(' ')[3];
      case 'D MMM YYYY':
        return date.split(' ')[2];
    }
  }

  toBEra(date, format) {
    const thisYear = this.getYearFormDateFormat(date, format);
    const bEra = parseInt(thisYear) + 543;
    return date.replace(thisYear, bEra);
  }

  toBEraYear(year) {
    return parseInt(year) + 543;
  }

  twoNumberYear(date, format) {
    const thisYear = this.getYearFormDateFormat(date, format);
    const _twoNumberYear = thisYear.slice(2);
    return date.replace(thisYear, _twoNumberYear);
  }

  getOtaFormatYear(lang, date, format = 'dd D MMM YYYY') {
    let _thisDate = moment(date).locale(lang).format(format);
    switch (format) {
      case 'dd D MMM YYYY':
        // if thai lang convert to Budda Era.
        if (lang === Language.th) {
          _thisDate = this.toBEra(_thisDate, format);
        } else if (lang === Language.en) {
          // add point stop on date string
          const _thisDateStr = _thisDate.split(' ')[0];
          const _thisDateStrWithPoint = _thisDateStr + '.';
          _thisDate = _thisDate.replace(_thisDateStr, _thisDateStrWithPoint);
        }
        break;
      default:
        if (lang === Language.th) {
          _thisDate = this.toBEra(_thisDate, format);
        }
        break;
    }
    // cut year format to two number.
    _thisDate = this.twoNumberYear(_thisDate, format);
    return _thisDate;
  }

  getDateWithFormat(lang, date, format = 'dd D MMM YYYY', timezone?: string) {
    let _thisDate;
    if (timezone === 'UTC') {
      _thisDate = moment(date).utc().locale(lang).format(format);
    } else {
      _thisDate = moment(date).locale(lang).format(format);
    }

    // if thai lang convert to Budda Era.
    if (lang === Language.th) {
      _thisDate = this.convertYearToBuddhist(_thisDate);
    }

    return _thisDate;
  }

  getDateWithFormatOnly(lang, date, format = 'dd D MMM YYYY') {
    let _thisDate = moment(date).locale(lang).format(format);
    return _thisDate;
  }

  lockBodyMice() {
    let isIOS = !!navigator.platform && /iPad|iPhone/.test(navigator.platform);
    let $body = $('body');
    if (isIOS) {
      $body.css({
        position: 'fixed'
      });
      $('input, textarea, select').attr('tabindex', '-1');
    } else {
      $body.css({
        height: '100%',
        overflow: 'hidden',
      });
    }
  }

  unlockBodyMice() {
    let isIOS = !!navigator.platform && /iPad|iPhone/.test(navigator.platform);
    let $body = $('body');
    if (isIOS) {
      $body.css({
        position: 'relative'
      });
      $('input, textarea', 'select').attr('tabindex', '0');
    } else {
      $body.css({
        height: '',
        overflow: '',
      });
    }
  }

  lockBody(isOverflowHidden = true) {
    // not desktop landing-page that have fullpage.js
    if (!(!window.matchMedia('(max-width: 1024px)').matches && $('.landing-page').length > 0)) {
      this.isLockedBody = true;
      let $doc = $('html, body');
      let $bodyContent = $('.body-content');
      if (window.pageYOffset) {
        this.scrollTop = window.pageYOffset;

        $bodyContent.css({
          top: - (this.scrollTop),
          position: 'relative'
        });
      }
      if (isOverflowHidden) {
        $doc.css({
          height: '100%',
          overflow: 'hidden'
        });
      } else {
        $doc = $('body');
        $doc.css({
          height: '100%',
          overflow: 'hidden'
        });
      }
    }
  }

  unlockBody() {
    // not desktop landing-page that have fullpage.js
    if (!(!window.matchMedia('(max-width: 1024px)').matches && $('.landing-page').length > 0)) {
      this.isLockedBody = false;
      const $doc = $('html, body');
      const $bodyContent = $('.body-content');

      $doc.css({
        height: '',
        overflow: ''
      });

      $bodyContent.css({
        top: '',
        position: ''
      });

      window.scrollTo(0, this.scrollTop);
      setTimeout(() => {
        this.scrollTop = null;
      }, 0);
    }
  }

  lockBodyBackdrop() {
    const $body = $('body');
    $body.addClass('-lock-backdrop');
  }

  unlockBodyBackdrop() {
    const $body = $('body');
    $body.removeClass('-lock-backdrop');
  }

  commaSeparateNumber(num) {
    const parts = ('' + num).split('.'), s = parts[0];
    let o = '', L;
    let i = L = s.length;
    while (i--) {
      o = (i === 0 ? '' : ((L - i) % 3 ? '' : ',')) + s.charAt(i) + o;
    }
    return o + (parts[1] === undefined ? '' : '.' + parts[1]);
  }

  indexToArray(number) {
    const newArray = [];
    const _numberInt = parseInt(number, 10);
    const isInt = number == _numberInt ? true : false;
    const lengthLoop = isInt ? _numberInt : _numberInt + 1;
    for (let i = 0; i < lengthLoop; i++) {
      if (i == lengthLoop - 1 && !isInt) {
        newArray.push(0.5);
      } else {
        newArray.push(1);
      }
    }
    return newArray;
  }

  convertYearToBuddhist(dateString: String): string {
    const splits = dateString.trim().split(` `);
    const plusYear = splits[splits.length - 1].length == 2 ? 43 : 543;
    splits[splits.length - 1] = (parseInt(splits[splits.length - 1]) + plusYear).toString();
    return splits.join(` `);
  }

  insertCurrencySymbol(amount: Number): string {
    return amount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }

  redirectPage(pathName: string, lang?: string) {
    window.location.href = lang ? pathName + `?lang=${lang}` : pathName;
  }

  isMobile() {
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true })(navigator.userAgent || navigator.vendor);
    return check || window.matchMedia('(max-width: 767px)').matches;
  }

  isScreenLessThan416() {
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true })(navigator.userAgent || navigator.vendor);
    return check || window.matchMedia('(max-width: 416px)').matches;
  }

  isTablet() {
    return window.matchMedia('(max-width: 1024px)').matches
  }

  getPriceRangeFormatText(number: number) {
    return 'THB ' + this.commaSeparateNumber(number);
  }

  getPriceRangeNumber(str: string, minPrice: number): number { // pattern THB x,xxx
    const _newStr = str.replace('THB', '').replace(' ', '').replace(',', '');

    if (isNaN(parseInt(_newStr)) || _newStr === '') {
      return minPrice;
    } else {
      return parseInt(_newStr);
    }
  }

  reFormatRangePrice(str: string, minPrice: number) {
    const _str = this.getPriceRangeNumber(str, minPrice);
    return this.getPriceRangeFormatText(_str);
  }

  getNumberBetweenMin(number: number, min: number, max: number): number {
    let newValue = number < min ? min : number;
    newValue = newValue > max ? min : newValue;
    return newValue;
  }

  getNumberBetweenMax(number: number, min: number, max: number): number {
    let newValue = number > max ? max : number;
    newValue = newValue < min ? max : newValue;
    return newValue;
  }

  getTextEllipsis(text: string, range: number) {
    let _text = text;
    if (text.length + 3 > range) {
      _text = text.slice(0, range) + '...';
    }
    return _text;
  }

  getNationalityList() {
    const nationality = nationalityList.list.map(data => data);
    return nationality;
  }

  encodeToCookie(data: string): string {
    return data ? this.base64Encoder(encodeURIComponent(data)) : '';
  }

  decodeFromCookie(data: string): string {
    return data ? decodeURIComponent(this.base64Decoder(data)) : '';
  }

  titleize(title: String): string {
    return title ? title.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()) : ``;
  }

  isSafari() {
    return (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) || navigator.userAgent.match(/(iPhone|iPod|iPad)/i);
  }

  isFirefox() {
    return (navigator.userAgent.indexOf('Firefox') != -1 && navigator.userAgent.indexOf('Chrome') == -1);
  }

  isIOS() {
    return navigator.userAgent.match(/(iPhone|iPod|iPad)/i);
  }

  convertDateFormat(timeStamp: any, formatTimeStamp?: string, returnFormat: string = 'D MMMM YYYY', language: string = undefined): string {
    if (!timeStamp) {
      return '';
    }

    const newDate = moment(timeStamp, formatTimeStamp, 'en').utc();
    const lang = language ? language : this.appConfig.getLanguage();
    switch (lang) {
      case Language.en:
        return newDate.locale(lang).add(7, 'hour').format(returnFormat);
      case Language.th:
      default:
        const convertDate = !returnFormat.includes('Y') ?
          newDate.locale(lang).add(7, 'hour').format(returnFormat)
          : this.convertYearToBuddhist(newDate.locale(lang).add(7, 'hour').format(returnFormat));
        return convertDate;
    }
  }

  randomStringWithLength(length = 8, chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghiklmnopqrstuvwxyz') {
    let result = '';
    for (let i = 0; i < length; ++i) {
      const rnum = Math.floor(Math.random() * chars.length);
      result += chars.substring(rnum, rnum + 1);
    }
    return result;
  }

  objectToQueryString(obj) {
    const query = Object.keys(obj)
      .filter(key => obj[key] !== '' && obj[key] !== null && obj[key] !== undefined)
      .map(key => `${key}=${obj[key]}`)
      .join('&');
    return query.length > 0 ? `?${query}` : '';
  }

  isNotExpiredURL(exp: Number): Boolean {
    return exp > moment().valueOf();
  }

  isJson(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  checkDateformat(data: string, format: string) {
    return moment(data, format, true).isValid();
  }

  debounce(func, delay) {
    let inDebounce;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(inDebounce);
      inDebounce = setTimeout(() => func.apply(context, args), delay);
    }
  }

  objectToFormData(obj, rootName): FormData {
    const formData = new FormData();

    function appendFormData(data, root) {
      root = root || '';
      if (data instanceof File) {
        formData.append(root, data);
      } else if (Array.isArray(data)) {
        for (let i = 0; i < data.length; i++) {
          appendFormData(data[i], root + '[' + i + ']');
        }
      } else if (typeof data === 'object' && data) {
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            if (root === '') {
              appendFormData(data[key], key);
            } else {
              appendFormData(data[key], root + '.' + key);
            }
          }
        }
      } else {
        if (data !== null && typeof data !== 'undefined') {
          formData.append(root, data);
        }
      }
    }

    appendFormData(obj, rootName);
    return formData;
  }

  oriantaionImage(file, callback2) {
    const callback = function (srcOrientation) {
      const reader2 = new FileReader();
      reader2.onload = function (e: any) {
        const srcBase64 = e.target.result;
        const img = new Image();

        img.onload = function () {
          const width = img.width;
          const height = img.height;
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          // set proper canvas dimensions before transform & export
          // srcOrientation not more than 9
          // srcOrientation 4 is image flip and clockwise
          if (4 < srcOrientation && srcOrientation < 9) {
            canvas.width = height;
            canvas.height = width;
          } else {
            canvas.width = width;
            canvas.height = height;
          }

          // transform context before drawing image
          switch (srcOrientation) {
            case 2:
              ctx.transform(-1, 0, 0, 1, width, 0);
              break;
            case 3:
              ctx.transform(-1, 0, 0, -1, width, height);
              break;
            case 4:
              ctx.transform(1, 0, 0, -1, 0, height);
              break;
            case 5:
              ctx.transform(0, 1, 1, 0, 0, 0);
              break;
            case 6:
              ctx.transform(0, 1, -1, 0, height, 0);
              break;
            case 7:
              ctx.transform(0, -1, -1, 0, height, width);
              break;
            case 8:
              ctx.transform(0, -1, 1, 0, 0, width);
              break;
            default:
              break;
          }

          // draw image
          ctx.drawImage(img, 0, 0);

          // export base64
          callback2(canvas.toDataURL());
        };

        img.src = srcBase64;
      };

      reader2.readAsDataURL(file);
    };

    const reader = new FileReader();
    reader.onload = function (e: any) {
      const view = new DataView(e.target.result);
      if (view.getUint16(0, false) !== 0xffd8) { return callback(-2); }
      const length = view.byteLength;
      let offset = 2;

      while (offset < length) {
        const marker = view.getUint16(offset, false);
        offset += 2;
        if (marker === 0xffe1) {
          if (view.getUint32((offset += 2), false) !== 0x45786966) { return callback(-1); };
          const little = view.getUint16((offset += 6), false) === 0x4949;
          offset += view.getUint32(offset + 4, little);
          const tags = view.getUint16(offset, little);
          offset += 2;
          for (let i = 0; i < tags; i++) {
            if (view.getUint16(offset + i * 12, little) === 0x0112) {
              return callback(view.getUint16(offset + i * 12 + 8, little));
            }
          }
        } else if ((marker & 0xff00) !== 0xff00) { break; } else { offset += view.getUint16(offset, false); }
      }
      return callback(-1);
    };
    reader.readAsArrayBuffer(file);
  }

  extractFileName(header: string, seperator: string) {
    const data = header.split(seperator);
    return data[1] ? data[1] : '';
  }

  verifyEmptyParams(queryParams) {
    for (const key in queryParams) {
      if (!queryParams[key]) {
        return true;
      }
    }
    return false;
  }

  public encodeQueryParamWrapper(value: any, encodeUri?: boolean) {
    return encodeUri ? encodeURIComponent(this.base64Encoder(JSON.stringify(value))) : this.base64Encoder(JSON.stringify(value));
  }
}



// WEBPACK FOOTER //
// ./src/app/services/utilities/utilities.service.ts